var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 10,
    viewBox: "0 0 34 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 9,
    rx: 1.5,
    stroke: "#BCB9CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.046 3.04H4.648V7H5.128V5.452H6.046C6.844 5.452 7.378 4.99 7.378 4.246C7.378 3.502 6.844 3.04 6.046 3.04ZM5.974 5.002H5.128V3.49H5.974C6.598 3.49 6.874 3.754 6.874 4.246C6.874 4.738 6.598 5.002 5.974 5.002ZM8.79011 6.55V5.218H10.5781V4.768H8.79011V3.49H11.0881V3.04H8.31011V7H11.1781V6.55H8.79011ZM15.2443 3.04H14.7883V5.836L14.8123 6.472H14.8063L14.3803 5.68L12.7303 3.04H12.1363V7H12.5923V4.204L12.5683 3.568H12.5743L12.9943 4.348L14.6503 7H15.2443V3.04ZM17.8205 3.04H16.5425V7H17.8205C19.0625 7 19.8125 6.292 19.8125 5.02C19.8125 3.748 19.0625 3.04 17.8205 3.04ZM17.8685 6.55H17.0225V3.49H17.8685C18.7745 3.49 19.3085 4.06 19.3085 5.02C19.3085 5.98 18.7745 6.55 17.8685 6.55ZM21.3468 3.04H20.8668V7H21.3468V3.04ZM25.7501 3.04H25.2941V5.836L25.3181 6.472H25.3121L24.8861 5.68L23.2361 3.04H22.6421V7H23.0981V4.204L23.0741 3.568H23.0801L23.5001 4.348L25.1561 7H25.7501V3.04ZM28.5724 5.002V5.452H29.8324V5.59C29.8324 6.274 29.3224 6.61 28.6624 6.61C27.7804 6.61 27.3124 6.016 27.3124 5.02C27.3124 4.024 27.8524 3.43 28.6564 3.43C29.2084 3.43 29.6284 3.67 29.8024 4.126L30.2404 3.886C29.9344 3.274 29.4424 2.98 28.6564 2.98C27.5464 2.98 26.8084 3.766 26.8084 5.02C26.8084 6.274 27.5164 7.06 28.6444 7.06C29.2504 7.06 29.6644 6.838 29.8924 6.466L29.9104 7H30.2704V5.002H28.5724Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTagIcon);
export default __webpack_public_path__ + "static/media/pending-tag-icon.b9a3bb83.svg";
export { ForwardRef as ReactComponent };